import { PrivateAppAPI } from 'src/data/common/PrivateAppAPI'

export class AuthenticationService {
  static async getShopifySecret(market: string): Promise<any> {
        const store_country = market.toLowerCase()
    
        const response = await PrivateAppAPI.request({
          url: `/aws/secretsmanager/getShopifySecret`,
          method: 'GET',
          params: {
            store_country
          }
        })
        return response.secretValue.secret
  }
}
